import { apiClient } from '@/lib/api-client';
import { Specification, SeverityLevel } from '@/models/specification';

class ErrorsService {
  async getSpecificationsList(): Promise<Specification[]> {
    const response = await apiClient.get<Specification[]>(
      '/api/Errors/GetSpecificationsList'
    );
    return response || [];
  }

  async getSeverityLevelsList(specificationId: number): Promise<SeverityLevel[]> {
    const response = await apiClient.get<SeverityLevel[]>(
      `/api/Errors/GetSeverityLevelsList?specificationId=${specificationId}`
    );
    return response || [];
  }
}

export const errorsService = new ErrorsService();
